import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/authConfig";
import { useAppSelector } from "../hooks/reduxhook";
import {
  getloadingforfullscreen,
  loadingforfullscreen,
} from "../redux/slices/loadingSlice";
import { useDispatch } from "react-redux";
import Loader from "../components/FullScreenLoader";

const Login = () => {
  const { instance } = useMsal();
  const dispatch = useDispatch();
  const isLoading = useAppSelector(getloadingforfullscreen);

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  useEffect(() => {
    dispatch(loadingforfullscreen(true));
    setTimeout(() => {
      handleLogin();
    }, 1200);
  }, []);

  return <>{isLoading && <Loader />}</>;
};

export default Login;
